import 'vite/modulepreload-polyfill';
import { datadogLogs } from '@datadog/browser-logs';

const ENVIRONMENTS = window.ALLBIRDS.environment.types;

// TODO: Move to settings https://app.asana.com/1/209680782572886/project/1208717489402917/task/1210639280858519?focus=true
const DATADOG_LOGGER_SECRETS = {
  [ENVIRONMENTS.DEVELOPMENT]: 'pubc6ad3e51ca841e98ee216de1da17b49c',
  [ENVIRONMENTS.PRODUCTION]: 'pub75727705086793f9de48d47553dd0fe9',
  [ENVIRONMENTS.STAGING]: 'pubc6ad3e51ca841e98ee216de1da17b49c',
};

const ENV_MAP = {
  [ENVIRONMENTS.DEVELOPMENT]: 'dev',
  [ENVIRONMENTS.PRODUCTION]: 'prod',
  [ENVIRONMENTS.STAGING]: 'test',
};

const SERVICE = 'allbirds-theme-2.0';
const clientName = 'Allbirds Shopify';

const { env } = window.ALLBIRDS.environment;

let initialized = false;
/**
 *
 * @returns string with a UUID format
 */
const uuidv4 = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/x|y/g, (match) =>
    ((Math.random() * 16) | (match === 'y' ? 8 : 0)).toString(16),
  );

const init = () => {
  if (!initialized) {
    const geoCode = `${window.Shopify.country}_WEB`;
    const fullShopName = window.Shopify.shop ?? '';
    const shopName = fullShopName.split('.')[0];

    const DEFAULT_ATTRIBUTES = {
      clientName,
      geoCode,
      isHydrogen: false,
      locale: window.Shopify.locale,
      shopName,
    };
    const clientToken = DATADOG_LOGGER_SECRETS[env];
    const envMapping = ENV_MAP[env];
    const pageId = uuidv4();
    datadogLogs.init({
      beforeSend: (log) => {
        Object.assign(log, { ...DEFAULT_ATTRIBUTES, pageId });
      },
      clientToken,
      env: envMapping,
      forwardErrorsToLogs: true,
      service: SERVICE,
    });
    initialized = true;
  }
};

/**
 * This methods logs a message in info level, object and/or exception to the Datadog Log.
 *
 * @param {string} message to log
 * @param {object} context any object with properties to add to the log message
 * @param {Error} error an exception to log
 */
const info = (message, context = {}, error) => {
  datadogLogs.logger.info(message, context, error);
  console.info(message, context);
};

/**
 * This methods logs a message in warn level, object and/or exception to the Datadog Log and browser console.
 *
 * @param {string} message to log
 * @param {object} context any object with properties to add to the log message
 * @param {Error} error an exception to log
 */
const warn = (message, context = {}, error) => {
  datadogLogs.logger.warn(message, context, error);
  console.warn(message, error, context);
};

/**
 * This methods logs a message in error level, object and/or exception to the Datadog Log and browser console.
 *
 * @param {string} message to log
 * @param {object} context any object with properties to add to the log message
 * @param {Error} error an exception to log
 */
const error = (message, context = {}, error) => {
  const errorMessage = message || error?.message || error || 'no error message';
  datadogLogs.logger.error(errorMessage, context, error);
  console.error(errorMessage, error, context);
};

/**
 * Retrieves the session ID of datadog.
 *
 * @returns {string} the session ID
 */
const getSessionId = () => {
  const logs = datadogLogs.getInternalContext();
  return logs?.session_id;
};

init();

export { error, getSessionId, info, warn };
